import { newCommonFormatCurrency } from "@/services/mathServices";
import { getUserDisplayName } from "@/services/userServices";
import { Invoice } from "../../../../types/types/invoice";
import { User } from "../../../../types/types/indexTypes";
import moment from "moment-timezone";

export function formatInvoiceText(invoice: Invoice, user: Partial<User>, text: string) {
    text = text.replaceAll("$TITLE", invoice.title ? invoice.title : "");
    text = text.replaceAll("$NUMBER", invoice.number ? invoice.number : "");
    text = text.replaceAll("$PRICE", newCommonFormatCurrency(invoice.netAmount));
    text = text.replaceAll("$INVOICE_DATE", moment(invoice.date).format("DD/MM/YYYY"));
    text = text.replaceAll("$INVOICE_DUE_DATE", moment(invoice.dueDate).format("DD/MM/YYYY"));
    text = text.replaceAll("$IBAN", user?.iban ? user.iban : "");
    text = text.replaceAll("$USER_NAME", getUserDisplayName(user));
    text = text.replaceAll("$COMPANY_NAME", invoice?.company.name ? invoice.company.name : "");
    text = text.replaceAll(
        "$CLIENT_COMPANY_NAME",
        invoice?.client.name ? invoice?.client.name : "",
    );
    text = text.replaceAll(
        "$RECEIVER_NAME",
        ((invoice.receiver as unknown as { firstname?: string; lastname?: string })?.firstname ||
            "") +
            " " +
            ((invoice.receiver as unknown as { firstname?: string; lastname?: string })?.lastname ||
                ""),
    );
    text = text.replaceAll("\n", "</p>\n<p>");
    return text;
}
